import { Component } from "react";

class Unavailable extends Component {
  state = {};
  render() {
    return <></>;
  }
}

export default Unavailable;
